import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-global-table-filters",
  templateUrl: "./global-table-filters.component.html",
  standalone: false,
})
export class GlobalTableFiltersComponent implements OnInit, OnDestroy {
  totalTasks = 0;
  private subscription!: Subscription;

  @Input() filterType = "None";
  @Input() total!: number;
  @Input() rejected!: number;
  @Input() isUsers = false;
  @Output() selectionChange: EventEmitter<{ filterType: string }> = new EventEmitter();

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  isValueNaN(value: number | null): boolean {
    return value === null || Number.isNaN(value);
  }

  public onSelectionChangeUnified(filterType: string | null): void {
    this.filterType = filterType ?? this.filterType;

    this.selectionChange.emit({ filterType: this.filterType });
  }
}
